export default null;throw new Error("Unable to resolve \"./inffast\" from npm:pngjs@5.0.0/browser.js");